'use strict';

module.exports = function(Chart) {

	Chart.PolarArea = function(context, config) {
		config.type = 'polarArea';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// ./node_modules/chart.js/src/charts/Chart.PolarArea.js
// module id = gCP2
// module chunks = 1